import { palette } from './system/palette';

export const highlight = {
  highlight: palette['aqua-200'],
  'highlight.ai': palette['plum-150'],
  'highlight.search': palette['lemon-500'],
};
